import React from "react";
import { PartnerData } from "@/pages/partners/types";
import PartnerTopFields from "@/pages/partners/components/PartnerTopFields";
import PartnerDetailFields from "@/pages/partners/components/PartnerDetailFields/PartnerDetailFields";
import PartnerSections from "@/components/layouts/QuickView/Partner/PartnerSections";
import { DetailedViewOptions } from "@/components/controls/OptionsDropdownMenu/OptionsDropdownMenu";

interface Props {
  partner: PartnerData | undefined;
  onUpdatePartnerField: (
    field: string,
    newValue: string | number | string[]
  ) => void;
  getCreateOptions?: () => DetailedViewOptions;
}

const PartnerQuickViewContent: React.FC<Props> = ({
  partner,
  onUpdatePartnerField,
  getCreateOptions
}) => {
  return (
    <div className="flex flex-col w-full gap-4">
      <PartnerTopFields
        className="flex-wrap gap-0 pl-5 pr-0"
        key={partner?.id}
        partner={partner}
        onUpdateField={(field, newValue) =>
          onUpdatePartnerField(field, newValue as string | number)
        }
      />
      <div className="flex flex-col w-full gap-4 pl-5">
        <PartnerDetailFields
          className="w-full px-4"
          partner={partner}
          onUpdateField={onUpdatePartnerField}
          isQuickView
        />
        <PartnerSections
          partner={partner}
          isQuickView
          getCreateOptions={getCreateOptions}
        />
      </div>
    </div>
  );
};

export default PartnerQuickViewContent;
